import { ReactComponent as HomeIcon } from '@Icons/menu/home.svg';
import BaseNameSideItem from '@Enum/BaseNameSideMenuItem.enum';
import { MenuItem } from '../../../types';
import { createItem } from '../../../utils/createItem';

const HomeMenuItem: MenuItem = createItem(
  BaseNameSideItem.HOME,
  BaseNameSideItem.HOME,
  <HomeIcon />
);

export default HomeMenuItem;
